export const LOGIN_REQUEST = {
    BASE_URL: "https://945cloud.knsh.com.tw/e/ebook_auth.asp",
    SIGN_UP_URL: "https://945cloud.knsh.com.tw/Auth/SignUp.asp",
    SEND_PWD_URL: "https://945cloud.knsh.com.tw/Auth/sendpwd.asp",
    ACTIVE_ACCOUNT_URL: "https://945cloud.knsh.com.tw/auth/active.asp"
}

export const postLogin = (account, password) => {
    const data = new URLSearchParams();
    data.append("Account", account);
    data.append("Password", password);
    return fetch(`${LOGIN_REQUEST.BASE_URL}`,
        {
            method: "POST",
            body: data,
            headers: {
                'content-type': 'application/x-www-form-urlencoded'
            }
        })
}